import React, {useState} from "react";
import {Container, Row, Col} from "react-bootstrap";
import ArrowLink from "../../common/ArrowLink/ArrowLink";
import "./DashboardSummary.scss";
import {useSelector} from "react-redux";
import Loader from "../../common/Loader/Loader";
import {useTranslation} from "react-i18next";
import {UserRoleEnum} from "../../../helpers/enums";
import {
  convertTime,
  SwitchUser,
  smallerSizeCents,
} from "../../../helpers/helpers";
import { Link } from "react-router-dom";

const DashboardSummary = () => {
  const auth = useSelector((state) => state.auth);
  const userProfile = SwitchUser(auth);
  const currentContracts = useSelector((state) => state.contracts.list);
  const bills = useSelector((state) => state.contracts.bills);
  const [lastBills] = bills.filter((ele) => {
    return ele.documentType !== 'NAC';
  });
  const usages = useSelector((state) => state.contracts.usages);
  const [lastUsage] = usages.filter((ele) => {
    return ele.invoiceNumber === lastBills?.invoiceNumber;
  });
  const {t} = useTranslation();
  const [contracts] = useState(currentContracts);
  const allReady = contracts && bills && usages;
  const SummaryUser = () => (
    <div>
      <Row>
        <div className={"DashboardSummary__card"} role="group" aria-labelledby="dashboard-summary-title">
          <div className={"DashboardSummary__title"}>
              <h2 id="dashboard-summary-title" className="headline-bold-fs3">{t("dashboard.summary.usages.title")}</h2>
            <div className={"display-none-mobile arrow"}>
            <Link className="gcap-cta" to={"/usages"} aria-label={`${t("dashboard.summary.usages.link.title")} - ${t("dashboard.summary.usages.title")}`}>
              {t("dashboard.summary.usages.link.title")}
              <i className="gc-icon-functional-arrow-right" aria-hidden="true"></i>
            </Link>
            </div>
          </div>
          <div className="DashboardSummary__info">
            <div className={"DashboardSummary__box--last-bills"}>
              <div className="DashboardSummary__box--last-bills-labels">
                <span className={"DashboardSummary__box__title paragraph-small-fs9"}>
                  {t("dashboard.summary.data.last-bill")}
                </span>
                <span className={"DashboardSummary__box__amount headline-bold-fs5"}>€
                  {lastBills?.amount > 0
                    ? smallerSizeCents(lastBills?.amount.toString())
                    : 0}{" "}
                </span>
              </div>
              <div className={"DashboardSummary__box__price"}>
                <span className={"DashboardSummary__box__text paragraph-small-fs9"}>
                  {lastBills?.isPaid ? t("dashboard.admin.header.payed") : t("bills.status.not_paid")}
                </span>
              </div>
            </div>
            <div className={"DashboardSummary__box--consumption"}>
              <span className={"DashboardSummary__box__title paragraph-small-fs9"}>
                {t("dashboard.summary.data.actual-consumption")}
              </span>
              <span className={"DashboardSummary__box__amount headline-bold-fs5"}>
                {lastUsage ? lastUsage.consumption : 0} m <sup>3</sup>
              </span>
            </div>
            <div className={"DashboardSummary__box--consumption-period"}>
              <span className={"DashboardSummary__box__title paragraph-small-fs9"}>
                {t("dashboard.summary.data.consumption-period")}
              </span>
              <span className={"DashboardSummary__box__amount headline-bold-fs5"}>
                {lastUsage ? (
                  <>
                    {convertTime(lastUsage?.startDate)} -{" "}
                    {convertTime(lastUsage?.endDate)}
                  </>
                ) : null}
              </span>
            </div>
          </div>
          <div className="DashboardSummary__metrics" style={{ paddingTop: '32px' }}>
            <div className={"DashboardSummary__box--invoice-num-mobile display-none-mobile"}>
              <span className={"DashboardSummary__box__title paragraph-small-fs9"}>
                {t("dashboard.summary.data.invoice-number")}
              </span>
              <span className={"DashboardSummary__box__title paragraph-large-fs7"}>
                {" "}
                {lastBills?.invoiceNumber}
              </span>
            </div>
             <div className={"DashboardSummary__box--invoice-num-mobile display-none-desk"}>
              <span className={"DashboardSummary__box__title paragraph-small-fs9"}>
                {t("dashboard.summary.data.invoice-number")}
              </span>
              <span className={"DashboardSummary__box__title paragraph-large-fs7"}>
                {lastUsage?.invoiceNumber}
              </span>
            </div>
            <div className={"DashboardSummary__box--rilevamento_mobile display-none-mobile"}>
              <span className={"DashboardSummary__box__title paragraph-small-fs9"}>
                {t("dashboard.summary.data.detection")}
              </span>
              <span className={"DashboardSummary__box__title paragraph-large-fs7"}>
                {lastBills ? (
                  <span>{convertTime(lastBills.issueDate)}</span>
                ) : null}{" "}
              </span>
            </div>
            <div className={"DashboardSummary__box--rilevamento_mobile display-none-desk"}>
              <span className={"DashboardSummary__box__title paragraph-small-fs9"}>
                {t("dashboard.summary.data.detection")}
              </span>
              <span className={"DashboardSummary__box__title paragraph-large-fs7"}>
                {lastBills ? (
                  <span>{convertTime(lastBills.issueDate)}</span>
                ) : null}
              </span>
            </div>
            <div className={"DashboardSummary__box--lettura_mobile"}>
              <span className={"DashboardSummary__box__title paragraph-small-fs9"}>
                {t("dashboard.summary.data.period-start")}
              </span>
              <span className={"DashboardSummary__box__title_lettura paragraph-large-fs7"}>
                {" "}
                {lastUsage?.initialMetreReading}
                <span>m</span>
                <sup >3</sup>
              </span>
            </div>
            <div className={"DashboardSummary__box--lettura_mobile"}>
              <span className={"DashboardSummary__box__title paragraph-small-fs9"}>
                {t("dashboard.summary.data.period-end")}
              </span>
              <span className={"DashboardSummary__box__title_lettura paragraph-large-fs7"}>
                {" "}
                <>
                  {lastUsage?.finalMetreReading}
                  <span>m</span>
                  <sup>3</sup>
                </>
              </span>
            </div>
          </div>
          <div className={"display-none-desk-link paragraph-main-fs8"}>       
              <Link className="gcap-cta" to={"/usages"} aria-label={`${t("dashboard.summary.usages.link.title")} - ${t("dashboard.summary.usages.title")}`}>
                  {t("dashboard.summary.usages.link.title")}
                  <i className="gc-icon-functional-arrow-right" aria-hidden="true"></i>
              </Link>
            </div>
        </div>
      </Row>
    </div>
  );
  /*  const SummaryCommunal = () => (
      <Row className={'DashboardSummary__card'}>
        <div className={'DashboardSummary__icon'}>
          <i className="gc-icon-service-verifica-metrica-2-col"><span className="path1"></span><span
            className="path2"></span><span className="path3"></span><span className="path4"></span></i>
        </div>
        {/!*Utenza comunale*!/}
        <Col className={'DashboardSummary__box'} xs={12} md={12}>
          <Row className={'mt-3'}>
            <Col xs={12} md={4} className={'DashboardSummery__box__step1'}>
              <h1 className={'DashboardSummary__box__title__h1'}>{t('dashboard.summary.data.counter')}</h1>
              <Row className={'mt-5'}>
                <Col xs={6} md={6}>
                  <h3 className={'DashboardSummary__box__title__h3'}>{t('dashboard.summary.data.number')}</h3>
                  <p className={'DashboardSummary__box__title__p'}>{metre?.serialNumber}</p>
                </Col>
                <Col xs={6} md={6}>
                  <h3 className={'DashboardSummary__box__title__h3'}>{t('dashboard.summary.data.diameter')}</h3>
                  <p className={'DashboardSummary__box__title__p'}>{metre?.diameter}</p>
                </Col>
              </Row>
              <Row className={'mt-2'}>
                <Col xs={6} md={6}>
                  <h3 className={'DashboardSummary__box__title__h3'}>{t('dashboard.summary.data.location')}</h3>
                  <p className={'DashboardSummary__box__title__p'}>{metre?.location}</p>
                </Col>
                <Col xs={6} md={6} className={'DashboardSummary_index'}>
                  <h3 className={'DashboardSummary__box__title__h3'}>{t('dashboard.summary.data.index-num')}</h3>
                  <p className={'DashboardSummary__box__title__p'}>{metre?.indicesNumber}</p>
                </Col>
              </Row>
            </Col>
            <Col xs={12} md={8}>
              <h1 className={'DashboardSummary__box__title__h1'}>{t('dashboard.summary.data.last-consumption')}</h1>
              <Row className={'mt-5'}>
                <Col xs={12} md={4} className={"mobile-margin-bottom"}>
                  <h3 className={'DashboardSummary__box__title__h3'}>{t('dashboard.summary.data.invoice-num')}</h3>
                  <p className={'DashboardSummary__box__title__p'}>{lastUsage?.invoiceNumber}</p>
                </Col>
                <Col xs={12} md={4} className={"mobile-margin-bottom"}>
                  <h3 className={'DashboardSummary__box__title__h3'}>{t('dashboard.summary.data.period')}</h3>
                  <p className={'DashboardSummary__box__title__p'}>{m(lastUsage?.startDate).subtract(1, 'days').format("DD/MM/YYYY")}- {m(lastUsage?.endDate).subtract(1, 'days').format("DD/MM/YYYY")} </p>
                </Col>
                <Col xs={12} md={4} className={"mobile-margin-bottom"}>
                  <h3 className={'DashboardSummary__box__title__h3'}>{t('dashboard.summary.data.consumption-start')}</h3>
                  <p className={'DashboardSummary__box__title__p'}>{lastUsage?.initialMetreReading}</p>
                </Col>
              </Row>
              <Row className={'mt-2'}>
                <Col xs={12} md={4} className={"mobile-margin-bottom"}>
                  <h3 className={'DashboardSummary__box__title__h3'}>{t('dashboard.summary.data.consumption-end')}</h3>
                  <p className={'DashboardSummary__box__title__p'}>{lastUsage?.finalMetreReading}</p>
                </Col>
                <Col xs={12} md={4} className={"mobile-margin-bottom"}>
                  <h3 className={'DashboardSummary__box__title__h3'}>{t('dashboard.summary.data.bills-type')}</h3>
                  <p className={'DashboardSummary__box__title__p'}>{lastUsage?.metreReadingStatus}</p>
                </Col>
                <Col xs={12} md={4} className={'d-flex align-items-end'}>
                  <ArrowLink to={'/visualizza-consumi'}>{t('dashboard.summary.data.consumption-view')}</ArrowLink>
                </Col>
              </Row>
  
            </Col>
          </Row>
        </Col>
      </Row>
    );*/
  const getSummary = () => {
    const summary = {
      [UserRoleEnum.PRIVATE]: <SummaryUser/>,
      [UserRoleEnum.COMPANY]: <SummaryUser/>,
      [UserRoleEnum.MUNICIPAL_USER]: <SummaryUser/>,
    };
    return summary[userProfile.role];
  };
  return allReady ? (
    <div className="DashboardSummary" data-testid="DashboardSummary">
      <Container>{getSummary()}</Container>
    </div>
  ) : (
    <Loader/>
  );
};

export default DashboardSummary;
